import { registerables } from "chart.js"

export const detection_zone_colors_by_name = {
    'Entrance Zone': 'rgba(54, 145, 13, 0.5)', // #36910d with 50% transparency
    'Exit Zone': 'rgba(194, 21, 0, 0.5)', // #C21500 with 50% transparency
    'Combined Entrance Exit Zone': 'rgba(221, 135, 37, 0.5)', // #dd8725 with 50% transparency
    'Checkout Waiting Zone': 'rgba(173, 57, 53, 0.5)', // #AD3935 with 50% transparency
    'Checkout Interaction Zone': 'rgba(211, 167, 65, 0.5)', // #D3A741 with 50% transparency
    'Product Zone': 'rgba(0, 79, 110, 0.5)', // #004F6E with 50% transparency
    'Demo Zone': 'rgba(98, 181, 217, 0.5)', // #62B5D9 with 50% transparency
    'Display Zone': 'rgba(17, 13, 147, 0.5)', // #110D93 with 50% transparency
    'Info Zone': 'rgba(13, 148, 136, 0.5)', // #0D9488 (teal) with 50% transparency
    'Service Zone': 'rgba(217, 119, 6, 0.5)', // #D97706 (amber) with 50% transparency
    'Pick Up Zone': 'rgba(126, 34, 206, 0.5)', // #7E22CE (purple) with 50% transparency
    'Cash Register Zone': 'rgba(210, 210, 210, 0.5)', // #D2D2Dd2 with 50% transparency
    // Phase 3 — the waiting and staff sides of the three service counters.
    // Queues take a LIGHTER shade of their counter's hue; every staff-side zone is
    // grey, because grey already means "where an employee stands, not a customer"
    // (the Cash Register convention). docs §28.2
    'Info Waiting Zone': 'rgba(94, 234, 212, 0.5)',     // #5EEAD4 light teal
    'Service Waiting Zone': 'rgba(252, 211, 77, 0.5)',  // #FCD34D light amber
    'Pick Up Waiting Zone': 'rgba(196, 181, 253, 0.5)', // #C4B5FD light purple
    'Info Desk Zone': 'rgba(184, 190, 196, 0.5)',       // #B8BEC4 grey
    'Service Desk Zone': 'rgba(168, 174, 180, 0.5)',    // #A8AEB4 grey
    'Pick Up Desk Zone': 'rgba(152, 160, 166, 0.5)'     // #98A0A6 grey
}

export const detection_zone_colors_by_name_solid = {
    'Entrance Zone': 'rgb(54, 145, 13)', // #36910d
    'Exit Zone': 'rgb(194, 21, 0)', // #C21500
    'Combined Entrance Exit Zone': 'rgb(221, 135, 37)', // #dd8725
    'Checkout Waiting Zone': 'rgb(173, 57, 53)', // #AD3935
    'Checkout Interaction Zone': 'rgb(211, 167, 65)', // #D3A741
    'Product Zone': 'rgb(0, 79, 110)', // #004F6E
    'Demo Zone': 'rgb(98, 181, 217)', // #62B5D9
    'Display Zone': 'rgb(17, 13, 147)', // #110D93
    'Info Zone': 'rgb(13, 148, 136)', // #0D9488 (teal)
    'Service Zone': 'rgb(217, 119, 6)', // #D97706 (amber)
    'Pick Up Zone': 'rgb(126, 34, 206)', // #7E22CE (purple)
    'Cash Register Zone': 'rgba(210, 210, 210)', // #D2D2D2
    'Info Waiting Zone': 'rgb(94, 234, 212)',     // #5EEAD4
    'Service Waiting Zone': 'rgb(252, 211, 77)',  // #FCD34D
    'Pick Up Waiting Zone': 'rgb(196, 181, 253)', // #C4B5FD
    'Info Desk Zone': 'rgb(184, 190, 196)',       // #B8BEC4
    'Service Desk Zone': 'rgb(168, 174, 180)',    // #A8AEB4
    'Pick Up Desk Zone': 'rgb(152, 160, 166)'     // #98A0A6
}

export const detection_zone_colors_by_typeid = {
    1: 'rgba(54, 145, 13, 0.5)', // #36910d with 50% transparency
    2: 'rgba(194, 21, 0, 0.5)', // #C21500 with 50% transparency
    3: 'rgba(221, 135, 37, 0.5)', // #dd8725 with 50% transparency
    4: 'rgba(173, 57, 53, 0.5)', // #AD3935 with 50% transparency
    5: 'rgba(211, 167, 65, 0.5)', // #D3A741 with 50% transparency
    6: 'rgba(0, 79, 110, 0.5)', // #004F6E with 50% transparency
    7: 'rgba(98, 181, 217, 0.5)', // #62B5D9 with 50% transparency
    8: 'rgba(17, 13, 147, 0.5)', // #110D93 with 50% transparency
    9: 'rgba(13, 148, 136, 0.5)', // #0D9488 (teal) — Info Zone
    10: 'rgba(217, 119, 6, 0.5)', // #D97706 (amber) — Service Zone
    11: 'rgba(126, 34, 206, 0.5)', // #7E22CE (purple) — Pick Up Zone
    12: 'rgba(94, 234, 212, 0.5)',  // #5EEAD4 — Info Waiting Zone
    13: 'rgba(252, 211, 77, 0.5)',  // #FCD34D — Service Waiting Zone
    14: 'rgba(196, 181, 253, 0.5)', // #C4B5FD — Pick Up Waiting Zone
    15: 'rgba(184, 190, 196, 0.5)', // #B8BEC4 — Info Desk Zone (staff side)
    16: 'rgba(168, 174, 180, 0.5)', // #A8AEB4 — Service Desk Zone (staff side)
    17: 'rgba(152, 160, 166, 0.5)', // #98A0A6 — Pick Up Desk Zone (staff side)
    999: 'rgba(210, 210, 210, 0.5)' // #D2D2Dd2 with 50% transparency
}

// new: a full mini-palette per zone
export const detection_zone_palettes = {
  'Entrance Zone': {
    segmentation: {
      walkBy:     'rgb(76, 187, 31)',   // a bit lighter
      shortLinger:'rgb(41, 123, 10)',   // a bit darker
      clearLinger:'rgb(23,  61,  6)',   // even darker
    },
    heatmap: [
      'rgba(241, 249, 232, 0.2)', // very light
      'rgba(206, 235, 188, 0.4)',
      'rgba(152, 204, 124, 0.6)',
      'rgba( 54, 145, 13,   0.8)'  // base at high opacity
    ]
  },
  'Exit Zone': {
    segmentation: {
      walkBy:     'rgb(220,  60, 10)',
      shortLinger:'rgb(160,  17,  0)',
      clearLinger:'rgb(110,  12,  0)',
    },
    heatmap: [
      'rgba(250, 236, 234, 0.2)',
      'rgba(244, 192, 185, 0.4)',
      'rgba(226,  89,  47, 0.6)',
      'rgba(194,  21,   0, 0.8)'
    ]
  },
  'Combined Entrance Exit Zone': {
    segmentation: {
      walkBy:     'rgb(238, 169,  80)',
      shortLinger:'rgb(187, 112,  31)',
      clearLinger:'rgb(135,  78,  22)',
    },
    heatmap: [
      'rgba(254, 245, 232, 0.2)',
      'rgba(248, 216, 180, 0.4)',
      'rgba(233, 157,  83, 0.6)',
      'rgba(221, 135,  37, 0.8)'
    ]
  },
  'Checkout Waiting Zone': {
    segmentation: {
      walkBy:     'rgb(200,  90, 85)',
      shortLinger:'rgb(140,  42, 39)',
      clearLinger:'rgb( 95,  28, 25)',
    },
    heatmap: [
      'rgba(251, 241, 241, 0.2)',
      'rgba(236, 192, 192, 0.4)',
      'rgba(203, 114, 113, 0.6)',
      'rgba(173,  57,  53, 0.8)'
    ]
  },
  'Checkout Interaction Zone': {
    segmentation: {
      walkBy:     'rgb(230, 207, 110)',
      shortLinger:'rgb(178, 141,  47)',
      clearLinger:'rgb(130, 103,  35)',
    },
    heatmap: [
      'rgba(254, 250, 237, 0.2)',
      'rgba(245, 230, 185, 0.4)',
      'rgba(226, 191, 112, 0.6)',
      'rgba(211, 167,  65, 0.8)'
    ]
  },
  'Product Zone': {
    segmentation: {
      walkBy:     'rgb( 70, 140, 180)',
      shortLinger:'rgb(  0,  50,  70)',
      clearLinger:'rgb(  0,  30,  40)',
    },
    heatmap: [
      'rgba(232, 242, 247, 0.2)',
      'rgba(174, 210, 231, 0.4)',
      'rgba( 60, 138, 186, 0.6)',
      'rgba(  0,  79, 110, 0.8)'
    ]
  },
  'Demo Zone': {
    segmentation: {
      walkBy:     'rgb(140, 210, 235)',
      shortLinger:'rgb( 60, 120, 145)',
      clearLinger:'rgb( 30,  70,  85)',
    },
    heatmap: [
      'rgba(239, 248, 250, 0.2)',
      'rgba(198, 227, 240, 0.4)',
      'rgba(109, 190, 228, 0.6)',
      'rgba( 98, 181, 217, 0.8)'
    ]
  },
  'Display Zone': {
    segmentation: {
      walkBy:     'rgb( 90,  80,210)',
      shortLinger:'rgb( 12,  10, 80)',
      clearLinger:'rgb(  8,   6, 50)',
    },
    heatmap: [
      'rgba(241, 240, 250, 0.2)',
      'rgba(195, 190, 244, 0.4)',
      'rgba(114, 110, 229, 0.6)',
      'rgba( 17,  13, 147, 0.8)'
    ]
  },
  'Cash Register Zone': {
    segmentation: {
      walkBy:     'rgb(240, 240,240)',
      shortLinger:'rgb(180, 180,180)',
      clearLinger:'rgb(120, 120,120)',
    },
    heatmap: [
      'rgba(250,250,250, 0.2)',
      'rgba(230,230,230, 0.4)',
      'rgba(200,200,200, 0.6)',
      'rgba(210,210,210, 0.8)'
    ]
  },
  'Info Zone': {
    segmentation: {
      walkBy:     'rgb( 60, 200, 188)',
      shortLinger:'rgb( 13, 148, 136)',
      clearLinger:'rgb(  9,  92,  84)',
    },
    heatmap: [
      'rgba(232, 250, 247, 0.2)',
      'rgba(176, 233, 226, 0.4)',
      'rgba( 51, 175, 161, 0.6)',
      'rgba( 13, 148, 136, 0.8)'
    ]
  },
  'Service Zone': {
    segmentation: {
      walkBy:     'rgb(245, 158,  11)',
      shortLinger:'rgb(217, 119,   6)',
      clearLinger:'rgb(146,  64,  14)',
    },
    heatmap: [
      'rgba(255, 247, 236, 0.2)',
      'rgba(252, 211, 154, 0.4)',
      'rgba(232, 145,  35, 0.6)',
      'rgba(217, 119,   6, 0.8)'
    ]
  },
  'Pick Up Zone': {
    segmentation: {
      walkBy:     'rgb(168,  85, 247)',
      shortLinger:'rgb(126,  34, 206)',
      clearLinger:'rgb( 76,  19, 120)',
    },
    heatmap: [
      'rgba(244, 235, 252, 0.2)',
      'rgba(208, 178, 240, 0.4)',
      'rgba(155,  73, 230, 0.6)',
      'rgba(126,  34, 206, 0.8)'
    ]
  },
  // --- phase 3: the waiting and staff sides of the three service counters --------
  'Info Waiting Zone': {
    segmentation: {
      walkBy:     'rgb(153, 246, 228)',
      shortLinger:'rgb( 94, 234, 212)',
      clearLinger:'rgb( 20, 184, 166)',
    },
    heatmap: [
      'rgba(240, 253, 250, 0.2)',
      'rgba(204, 251, 241, 0.4)',
      'rgba(153, 246, 228, 0.6)',
      'rgba( 94, 234, 212, 0.8)'
    ]
  },
  'Service Waiting Zone': {
    segmentation: {
      walkBy:     'rgb(253, 230, 138)',
      shortLinger:'rgb(252, 211,  77)',
      clearLinger:'rgb(245, 158,  11)',
    },
    heatmap: [
      'rgba(255, 251, 235, 0.2)',
      'rgba(254, 243, 199, 0.4)',
      'rgba(253, 230, 138, 0.6)',
      'rgba(252, 211,  77, 0.8)'
    ]
  },
  'Pick Up Waiting Zone': {
    segmentation: {
      walkBy:     'rgb(221, 214, 254)',
      shortLinger:'rgb(196, 181, 253)',
      clearLinger:'rgb(139,  92, 246)',
    },
    heatmap: [
      'rgba(245, 243, 255, 0.2)',
      'rgba(237, 233, 254, 0.4)',
      'rgba(221, 214, 254, 0.6)',
      'rgba(196, 181, 253, 0.8)'
    ]
  },
  // The staff-side zones are grey on purpose (the Cash Register convention): nobody
  // in them is a customer. They are never segmented into lingerers either — a member
  // of staff is not a walk-by — so these ramps exist only so a generic chart keyed by
  // zone name cannot render colourless.
  'Info Desk Zone': {
    segmentation: {
      walkBy:     'rgb(209, 213, 218)',
      shortLinger:'rgb(184, 190, 196)',
      clearLinger:'rgb(140, 147, 154)',
    },
    heatmap: [
      'rgba(246, 247, 248, 0.2)',
      'rgba(226, 229, 232, 0.4)',
      'rgba(209, 213, 218, 0.6)',
      'rgba(184, 190, 196, 0.8)'
    ]
  },
  'Service Desk Zone': {
    segmentation: {
      walkBy:     'rgb(199, 204, 210)',
      shortLinger:'rgb(168, 174, 180)',
      clearLinger:'rgb(126, 133, 140)',
    },
    heatmap: [
      'rgba(244, 245, 246, 0.2)',
      'rgba(220, 223, 227, 0.4)',
      'rgba(199, 204, 210, 0.6)',
      'rgba(168, 174, 180, 0.8)'
    ]
  },
  'Pick Up Desk Zone': {
    segmentation: {
      walkBy:     'rgb(186, 192, 198)',
      shortLinger:'rgb(152, 160, 166)',
      clearLinger:'rgb(112, 120, 127)',
    },
    heatmap: [
      'rgba(242, 243, 244, 0.2)',
      'rgba(214, 218, 222, 0.4)',
      'rgba(186, 192, 198, 0.6)',
      'rgba(152, 160, 166, 0.8)'
    ]
  },
}